import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Daterange } from '@northfork/ng-basics'
import { SecurityData } from '../../models/security-data.model'
import {
  displaySecurityAssetId,
  displaySecurityDescription,
} from '../../utils/security-data-utils'

@Component({
  selector: 'hs-distributions-properties',
  templateUrl: './distributions-properties.component.html',
  styleUrls: ['./distributions-properties.component.scss'],
})
export class DistributionsPropertiesComponent {
  private _securityData: SecurityData | null = null
  @Output() securityDataForMMF = new EventEmitter<SecurityData>()

  private _hasLlaRates = false

  @Input() set securityData(value: SecurityData | null) {
    this._securityData = value
    this.buildCurrentProperties()
    this.buildSecurityDescription()
    this.securityDataForMMF.emit(value ?? undefined)
  }

  /** Whether any displayed distribution row took its rate from LLA. Drives the LLA source marker. */
  @Input() set hasLlaRates(value: boolean | null) {
    this._hasLlaRates = value ?? false
    this.buildSecurityDescription()
  }

  @Output() dateRangeChange = new EventEmitter<Daterange>()

  currentProperties: string[] = []
  securityDescription: string | null = null

  onDateRangeChanged(newDateRange: Daterange) {
    this.dateRangeChange.emit(newDateRange)
  }

  private buildCurrentProperties() {
    const properties = []
    if (this._securityData) {
      properties.push(displaySecurityAssetId(this._securityData))
    }
    this.currentProperties = properties
  }

  private buildSecurityDescription() {
    if (!this._securityData) {
      this.securityDescription = null
      return
    }
    this.securityDescription = displaySecurityDescription(
      this._securityData,
      this._hasLlaRates,
    )
  }
}
